enum TipoInventario {
        Unitario = 0,
        Parcial = 1,
        Completo = 2
}

export default TipoInventario;